import { useSnackbar } from 'notistack'
import React, { FC, useEffect, useRef, useState } from 'react'
import { CostumerPropsType, CostumerType } from '../../../api/appAPI'
import CostumerUIBox from './CostumerUIBox'
import { EnqueueSnackbarType, showMessage } from '../../../components/common/Helpers'

interface IProps {
    costumer: CostumerType
    statusList: string[]

    onDialogClose(): void
    editCostumer(id: number, costumerProps: CostumerPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const EditCostumer: FC<IProps> = ({ costumer, editCostumer, ...props }) => {
    const idRef = useRef(costumer.id)
    const [costumerProps, setCostumerProps] = useState({
        firstName: costumer.firstName,
        lastName: costumer.lastName,
        email: costumer.email,
        status: costumer.status,
        phone: costumer.phone,
        zip: costumer.zip,
        address1: costumer.address1,
        address2: costumer.address2,
        city: costumer.city,
        province: costumer.province,
        country: costumer.country,
        companyEmail: costumer.companyEmail,
        creatorEmail: costumer.creatorEmail,
        note: costumer.note,
    })
    const costumerPropsRef = useRef(costumerProps)

    const [needSave, setNeedSave] = useState(false)
    const needSaveRef = useRef(needSave)

    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        idRef.current = costumer.id
        setCostumerProps({
            firstName: costumer.firstName,
            lastName: costumer.lastName,
            email: costumer.email,
            status: costumer.status,
            phone: costumer.phone,
            zip: costumer.zip,
            address1: costumer.address1,
            address2: costumer.address2,
            city: costumer.city,
            province: costumer.province,
            country: costumer.country,
            companyEmail: costumer.companyEmail,
            creatorEmail: costumer.creatorEmail,
            note: costumer.note,
        })

        setNeedSave(false)

    }, [costumer])

    useEffect(() => {
        costumerPropsRef.current = costumerProps
        needSaveRef.current = needSave
    }, [needSave, costumerProps])

    useEffect(() => () => {
        if (needSaveRef.current) {
            if (window?.confirm('Save costumer?')) {
                handleSaveClick()
            }
        }
    }, [costumer])

    const handleFirstNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            firstName: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleLastNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            lastName: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleEmailChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            email: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleStatusChange = (value: string) => {
        setCostumerProps({
            ...costumerProps,
            status: value
        })
        setNeedSave(true)
    }
    const handlePhoneChange = (value: string) => {
        setCostumerProps({
            ...costumerProps,
            phone: value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleZipChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            zip: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleAddress1Change = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            address1: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleAddress2Change = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            address2: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleCityChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            city: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleProvinceChange = (value: string) => {
        setCostumerProps({
            ...costumerProps,
            province: value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleCountryChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            country: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }
    const handleNoteChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCostumerProps({
            ...costumerProps,
            note: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }

    const handleSaveClick = () => {
        const firstName = costumerPropsRef.current.firstName
        const lastName = costumerPropsRef.current.lastName
        const email = costumerPropsRef.current.email
        const status = costumerPropsRef.current.status
        const phone = costumerPropsRef.current.phone
        const zip = costumerPropsRef.current.zip
        const address1 = costumerPropsRef.current.address1
        const address2 = costumerPropsRef.current.address2
        const city = costumerPropsRef.current.city
        const province = costumerPropsRef.current.province
        const country = costumerPropsRef.current.country
        const companyEmail = costumerPropsRef.current.companyEmail
        const creatorEmail = costumerPropsRef.current.creatorEmail
        const note = costumerPropsRef.current.note

        if (firstName === '') {
            showMessage(enqueueSnackbar, "Enter first name")
            return
        }

        if (lastName === '') {
            showMessage(enqueueSnackbar, "Enter last name")
            return
        }

        if (email === '') {
            showMessage(enqueueSnackbar, "Enter email")
            return
        }

        // if (props.statusList.length > 0) {
        //     if (status === '') {
        //         showMessage(enqueueSnackbar, "Choose status")
        //         return
        //     }
        // }

        needSaveRef.current = false
        setNeedSave(false)

        const newCostumerProps = {
            firstName, lastName,
            email, status, phone, zip, address1, address2,
            city, province, country, companyEmail, creatorEmail, note
        } as CostumerPropsType

        editCostumer(idRef.current, newCostumerProps, enqueueSnackbar)
        props.onDialogClose()
    }

    return (
        <CostumerUIBox
            title='Edit Customer'
            statusList={props.statusList}
            firstName={{
                value: costumerProps.firstName,
                onChange: handleFirstNameChange
            }}
            lastName={{
                value: costumerProps.lastName,
                onChange: handleLastNameChange
            }}
            email={{
                value: costumerProps.email,
                onChange: handleEmailChange
            }}
            status={{
                value: costumerProps.status,
                onChange: handleStatusChange
            }}
            phone={{
                value: costumerProps.phone,
                onChange: handlePhoneChange
            }}
            zip={{
                value: costumerProps.zip,
                onChange: handleZipChange
            }}
            address1={{
                value: costumerProps.address1,
                onChange: handleAddress1Change
            }}
            address2={{
                value: costumerProps.address2,
                onChange: handleAddress2Change
            }}
            city={{
                value: costumerProps.city,
                onChange: handleCityChange
            }}
            province={{
                value: costumerProps.province,
                onChange: handleProvinceChange
            }}
            country={{
                value: costumerProps.country,
                onChange: handleCountryChange
            }}
            note={{
                value: costumerProps.note,
                onChange: handleNoteChange
            }}


            button={{
                text: 'Save',
                onClick: handleSaveClick
            }}

            needSave={needSave}
            // editable={markup.editable === '1'}
            onDialogClose={props.onDialogClose}
        />
    )
}

export default EditCostumer